import React from 'react';
import { Fragment } from 'react';
import Tilt from 'react-vanilla-tilt';
import './common.css'
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import CameraIcon from '@material-ui/icons/PhotoCamera';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { Link } from 'react-router-dom';
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Box from "@material-ui/core/Box";

// --- Fill Image Card Component Imports --- //
import {
  FiCard,
  FiCardActions,
  FiCardContent,
  FiCardMedia
} from "./FullImageCard"













function Copyright() {
    return (
      <Typography variant="body2" color="textSecondary" align="center">
        {'Copyright © '}
        <Link color="inherit" href="https://material-ui.com/">
          Your Website
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    );
  }

  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    },
    /**
     * Max Card with for demo
     * same values used in Material-Ui Card Demos
     */
    card: {
      maxWidth: 345,
      maxHeight:"450px",
    },
  
    /**
     * Applied to Orginal Card demo
     * Same vale used in Material-ui Card Demos
     */
    media: {
      height: 440,
    },
  
    /**
     * Demo stlying to inclrease text visibility
     * May verry on implementation
     */
    fiCardContent: {
      top:0,
      height:220,
      backgroundColor: "rgba(0,0,0,.34)",
      color: "#ffffff",
    },
    fiCardContentTextSecondary: {
      zIndex:"9999",
      paddingTop:170,
      color: "white",
      fontSize:"25px",
      textAlign:"center"
    },
  
    
    cardGrid: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
    },
    tilt:{
      boxShadow:"none !important"
    }
    
    
  }));
  
  const cards = [
    {
    PlanName:"Plan A",
    PlanDec:"ACCMODATION Plan",
    PlanPrice:"500",
    PlanId:"1",
    }, 
    {
      PlanName:"Plan B",
      PlanDec:"MEAL PLAN",
      PlanPrice:"1000",
      PlanId:"2",
      },
      {
        PlanName:"Plan c",
        PlanDec:"MONTHLY PLAN",
        PlanPrice:"10000",
        PlanId:"3",
        }
    ];


   

 function Plans() {

  // const [BookingPlan, setBookingPlan] = useState(initialState)

  // const handleClick = (plan) =>{
  //   setBookingPlan(plan);
  // }
    const classes = useStyles();
  return (
    <Fragment className="main">
      
      {/* <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">

          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            
          </div>
        </div>
      </div> */}




<Container className={classes.cardGrid} maxWidth="lg">

          {/* End hero unit */}
          <Typography variant = "h3" align="center">
               PAKAGES
            </Typography>
          
          <Grid className="my-5" container spacing={4}>
            
            {cards.map((card) => (
                <Grid item key={card} xs={12} sm={6} md={4}>
                  <Tilt option={{max:50, speed:600}} style={{boxShadow:"none !important"}} className={classes.tilt}>

                  <Box my={3} >
                  
                  <FiCard className={classes.card}>
                    <FiCardMedia
                      media="picture"
                      alt="Contemplative Reptile"
                      image="/asserts/images/total/image1.png"
                      title="Contemplative Reptile"
                    />
                    <FiCardContent className={classes.fiCardContent}>
                      <Typography  gutterBottom variant="h5" component="span">
                        {card.PlanName} 
                        
                      </Typography>
                      <Typography align="right"  gutterBottom variant="p" component="span">
                      <span style={{alignItems:"end",paddingLeft:"58%"}}>
                          {card.PlanPrice}
                        </span>
                      </Typography>
                      <Typography
                      
                        variant="body2"
                        className={classes.fiCardContentTextSecondary}
                        component="p"
                      >
                       <strong>
                         {card.PlanDec}
                       </strong>
                      </Typography>
                    </FiCardContent>
                    <FiCardActions className={classes.fiCardContent}>
                      
                      <Button fullWidth size="large" color="inherit" variant="outlined"
                      component={Link} to="/booking" 
                      >
                        Book Now
                      </Button>
                    </FiCardActions>
                  </FiCard>
                </Box>
                
                  </Tilt>
                </Grid>
            ))}
          </Grid>
        </Container>




    </Fragment>
  );
}


export default Plans;





// <Grid className="my-5" container spacing={4}>
//             {cards.map((card) => (
                
//               <Grid item key={card} xs={12} sm={6} md={4}>
//                   <Tilt option={{max:50, speed:600}} style={{boxShadow:"none !important"}} >
//                 <Card className={classes.card}>
//                   <CardMedia
//                     className={classes.cardMedia}
//                     image="https://source.unsplash.com/random"
//                     title="Image title"
//                   />
//                   <CardContent className={classes.cardContent}>
//                     <Typography gutterBottom variant="h5" component="h2">
//                       Plan Name
//                     </Typography>
//                     <Typography>
//                       Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi delectus accusamus a voluptatibus
//                        consequatur modi incidunt dolore ipsa quis 
//                        atque eum nobis perspiciatis amet reiciendis ex, ab, quisquam, optio omnis.
//                     </Typography>
//                     <CardActions>
//                     <Button size="large" color="primary" variant="contained" fullWidth  component={Link} to="/booking">
//                       BOOK NOW
//                     </Button>
//                     {/* <Button size="small" color="primary">
//                       Edit
//                     </Button> */}
//                   </CardActions>
//                   </CardContent>
                  
//                 </Card>
//                 </Tilt>
//               </Grid>
              
//             ))}
//           </Grid>













